import PropTypes from 'prop-types'

import QuestionRow, {QUESTION_STATUS} from './QuestionRow'
import {evergreenPrompt, newEvergreenPromptId} from './lifeStoryContent'
import {promptIsAnswered} from './lifeStoryTools'

import './addStoryDrawer.scss'

const PlusIcon = () => (
  <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.4' strokeLinecap='round' aria-hidden='true'>
    <path d='M12 5v14M5 12h14' />
  </svg>
)

/**
 * Review screen's "+ Add a story" link for a chapter expands in place into
 * the chapter's unanswered questions including the evergreen
 * "Is there anything else…" question. Review screen keeps at most one drawer open.
 */
const AddStoryDrawer = ({chapter, stories, open, toggle, openPrompt}) => {
  const unansweredPrompts = chapter.prompts.filter(prompt => !promptIsAnswered({promptId: prompt.id, stories}))
  const drawerId = `ls-add-story-drawer-${chapter.key}`
  // Every chapter's trigger reads "Add a story", so the accessible name
  // carries the chapter (the visible text stays as is).
  const triggerLabel = open ? `Cancel adding a story to ${chapter.name}` : `Add a story to ${chapter.name}`

  return (
    <div className='add-story-drawer'>
      <button
        aria-controls={drawerId}
        aria-expanded={open}
        aria-label={triggerLabel}
        className={`ls-add-story-trigger${open ? ' open' : ''}`}
        onClick={toggle}>
        <PlusIcon />
        <span>{open ? 'Cancel' : 'Add a story'}</span>
      </button>
      {/*
        Always rendered so it can slide closed as well as open; inert while closed.
        React 18 drops a boolean `inert`, so it's set as an empty-string attribute
        (switch to `inert={!open}` on React 19, which treats '' as false).
      */}
      <div
        className={`ls-add-story-list${open ? ' open' : ''}`}
        id={drawerId}
        inert={open ? null : ''}
        aria-hidden={!open}>
        <div className='ls-add-story-list-inner'>
          <div className='ls-add-story-list-body'>
            <div className='ls-add-story-label'>Pick a question to write about next:</div>
            {
              unansweredPrompts.map(prompt => (
                <QuestionRow
                  key={prompt.id}
                  onClick={() => openPrompt(prompt.id)}
                  question={prompt.question}
                  status={QUESTION_STATUS.NEW}
                />
              ))
            }
            <QuestionRow
              evergreen
              onClick={() => openPrompt(newEvergreenPromptId(chapter.key))}
              question={evergreenPrompt({chapter, promptId: null}).question}
              status={QUESTION_STATUS.NEW}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

AddStoryDrawer.propTypes = {
  chapter: PropTypes.object,
  open: PropTypes.bool,
  openPrompt: PropTypes.func,
  stories: PropTypes.array,
  toggle: PropTypes.func
}

export default AddStoryDrawer
